document.addEventListener('DOMContentLoaded', function() {
// First, select all elements we'll need
    const dots = document.querySelectorAll('.pergolux-video-section .slider-navigation-dots .slide-dot');
    const prevArrow = document.querySelector(".pergolux-video-section .btn--prev");
    const nextArrow = document.querySelector(".pergolux-video-section .btn--next");

    // Function to update active dot
    function updateDots(activeIndex) {
        dots.forEach((dot, index) => {
            if (index === activeIndex) {
                dot.classList.add('dot--active');
            } else {
                dot.classList.remove('dot--active');
            }
        });
    }

    // Initialize Main Thumbnail Slider
    const initialIndex = window.matchMedia('(max-width: 749px)').matches ? 1.2 : 2.3;
    const slider = new KeenSlider(".pdp-thumbnail-keen-slider", {
        slides: {
            perView: initialIndex,
            spacing: 15,
        },
        created: (instance) => {
            updateDots(instance.track.details.rel);
           // Check the number of slides and disable arrows/dots if necessary
            const slideCount = instance.slides.length;
            if (slideCount <= 2) {
                prevArrow.classList.add('disable-arrow');
                nextArrow.classList.add('disable-arrow');
                dots.forEach(dot => dot.classList.add('disable-arrow'));
            }
        },
        slideChanged: (instance) => {
            updateDots(instance.track.details.rel);
        },
    });

    // Add event listeners for the prev and next buttons
    prevArrow.addEventListener("click", () => {
        slider.prev();
    });

    nextArrow.addEventListener("click", () => {
        slider.next();
    });

    // Add click event listeners to dots
    dots.forEach((dot, index) => {
        dot.addEventListener('click', () => {
            slider.moveToIdx(index);
        });
    });

    // Initialize dots on load
    updateDots(0);
    
    // // Initialize Main Thumbnail Slider
    // const initialIndex = window.matchMedia('(max-width: 749px)').matches ? 1.2 : 2.3;
    // const slider = new KeenSlider(".pdp-thumbnail-keen-slider", {
    //     slides: {
    //         perView: initialIndex,
    //         spacing: 15,
    //     },
    // });

    // // Get the prev and next arrow buttons
    // const prevArrow = document.querySelector(".pergolux-video-section .btn--prev");
    // const nextArrow = document.querySelector(".pergolux-video-section .btn--next");

    // // Add event listeners for the prev and next buttons
    // prevArrow.addEventListener("click", () => {
    //     slider.prev();
    // });

    // nextArrow.addEventListener("click", () => {
    //     slider.next();
    // });

     // Video Modal Functionality
    const videoModal = document.getElementById("pgxVideoModal");
    const closeButton = document.querySelector(".pxg-slider-modal--button-close");
    let mainSlider, thumbnails;
    let currentVideos = [];
    let lastOpenedSlideIndex = 0;

    function playCurrentVideo(instance) {
        // Pause all videos first
        pauseAllVideos();
        
        const currentSlide = instance.slides[instance.track.details.rel];
        const video = currentSlide.querySelector("video");
        if (video) {
            // Reset video state
            video.currentTime = 0;
            video.muted = false;
            
            // Try to play with sound, fallback to muted if needed
            const playPromise = video.play();
            
            if (playPromise !== undefined) {
                playPromise.catch(e => {
                    console.log("Autoplay prevented:", e);
                    video.muted = true;
                    video.play().catch(e => console.log("Muted autoplay also prevented:", e));
                });
            }
            currentVideos.push(video);
        }
    }

    function initializeVideoSliders(slideIndex = 0) {
        // Destroy existing sliders if they exist
        if (mainSlider) {
            mainSlider.destroy();
            thumbnails.destroy();
        }
        
        mainSlider = new KeenSlider(".pgx-main-video-keen-slider", {
            slides: { perView: 1, spacing: 0 },
            vertical: true,
            initial: slideIndex,
            created: (instance) => playCurrentVideo(instance),
            slideChanged: (instance) => playCurrentVideo(instance)
        });

        thumbnails = new KeenSlider(
            ".pgx-player-nav-slide-container",
            {
                initial: slideIndex,
                slides: { perView: 3, spacing: 10 },
                vertical: true,
            },
            [ThumbnailPlugin(mainSlider, slideIndex)]
        );
    }


     // Get the prev and next arrow buttons
      const prevArrow2 = document.querySelector(".pgx-player-nav--button-prev");
      const nextArrow2 = document.querySelector(".pgx-player-nav--button-next");
  
      // Add event listeners for the prev and next buttons
      prevArrow2.addEventListener("click", () => {
          mainSlider.prev();
      });
  
      nextArrow2.addEventListener("click", () => {
          mainSlider.next();
      });

    // Thumbnail plugin remains the same
    // Modified ThumbnailPlugin to accept initial index
    function ThumbnailPlugin(main, initialIndex = 0) {
        return (slider) => {
            function removeActive() {
                slider.slides.forEach((slide) => {
                    slide.classList.remove("pgx-player-nav-slide-active");
                });
            }
            
            function addActive(idx) {
                removeActive();
                slider.slides[idx].classList.add("pgx-player-nav-slide-active");
            }
    
            function addClickEvents() {
                slider.slides.forEach((slide, idx) => {
                    slide.addEventListener("click", () => {
                        main.moveToIdx(idx);
                    });
                });
            }
    
            slider.on("created", () => {
                addClickEvents();
                // Set initial active slide immediately
                addActive(initialIndex);
                
                main.on("animationStarted", (main) => {
                    const next = main.animator.targetIdx || 0;
                    const relIdx = main.track.absToRel(next);
                    addActive(relIdx);
                    slider.moveToIdx(Math.min(slider.track.details.maxIdx, next));
                });
            });
        };
    }

    // Click event for thumbnail slides
    document.querySelectorAll(".pdp-thumbnail-keen-slider .keen-slider__slide").forEach((slide, index) => {
        slide.addEventListener("click", () => {
            videoModal.style.display = "block";
            document.body.style.overflow = "hidden";
            lastOpenedSlideIndex = index;
            initializeVideoSliders(index);
        });
    });

    function closeModal() {
        videoModal.style.display = "none";
        document.body.style.overflow = "";
        pauseAllVideos();
        
        // Clear the currentVideos array completely
        currentVideos = [];
    }

    closeButton.addEventListener("click", closeModal);
    videoModal.addEventListener("click", (e) => {
        if (e.target === videoModal) closeModal();
    });

    // Pause all videos and reset them
    function pauseAllVideos() {
        currentVideos.forEach(video => {
            video.pause();
            video.currentTime = 0;
        });
        currentVideos = [];
    }
});